var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "modal-container modal-container-80 jsonPopup",
            style: { "max-height": _vm.getMaxHeightClient() + "px" },
            on: { mousedown: _vm.dontClose },
          },
          [
            _c(
              "div",
              [
                _c(
                  "b-row",
                  [
                    _c("b-col", { staticStyle: { "text-align": "end" } }, [
                      _c("i", {
                        staticClass: "fa fa-times close-button",
                        staticStyle: { "font-size": "20px" },
                        on: { click: _vm.handleMouseDown },
                      }),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modal-body",
                staticStyle: { overflow: "auto" },
                style: { "max-height": _vm.getMaxHeightClient() * 0.85 + "px" },
              },
              [
                _c(
                  "b-container",
                  { attrs: { fluid: "" } },
                  [
                    _vm.isPopupActive
                      ? _c("b-row", [
                          _c("div", { staticClass: "break h5" }, [
                            _c("pre", { attrs: { lang: "json" } }, [
                              _c("code", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.highlightedJsonData),
                                },
                              }),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "p-0 m-0",
                    attrs: { lg: "2", sm: "3", cols: "6" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.download(_vm.jsonDetailsData.data)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.dwnld")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }